import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { markDesktopDocument } from "./desktop/window-chrome";
import { useCatalogStore } from "./store/catalog-store";
import { useProjectStore } from "./store/project-store";
import "./index.css";

markDesktopDocument();

if (process.env.NODE_ENV !== "production") {
  (window as unknown as { __store: typeof useProjectStore; __catalog: typeof useCatalogStore }).__store = useProjectStore;
  (window as unknown as { __catalog: typeof useCatalogStore }).__catalog = useCatalogStore;
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
